"use client";

import type { ReactNode } from "react";

import { useRoomDetailDrawer } from "../../../../../../_components/room-detail/room-detail-drawer-provider";
import { Link } from "../../../../../../_components/ui/link";

import { buildRoomDetailPayloadForSiteReserve } from "./_utils/build-room-detail-payload-for-site-reserve";

const CARD_ACTION_CLASS_NAME =
  "group hover:bg-dx-bg-base-hover flex items-start gap-[16px] px-[16px] py-[8px] transition-colors duration-150";

/**
 * 部屋タイプカードのクリック挙動を出し分ける。会員は詳細ページへの `<Link>`、
 * 非会員はモーダル (RoomDetailDrawer) 起動ボタン。
 * 非会員側は roomTypeId のみで開けるため、詳細ページ用の slug (detailHref) 有無に依存しない。
 */
export function RoomTypeCardAction({
  hasReservablePlan,
  detailHref,
  roomTypeId,
  areaSlug,
  siteSlug,
  children,
}: {
  hasReservablePlan: boolean;
  detailHref: string | null;
  roomTypeId: string;
  areaSlug: string;
  siteSlug: string;
  children: ReactNode;
}) {
  const { open } = useRoomDetailDrawer();

  if (!hasReservablePlan) {
    return (
      <button
        type="button"
        data-testid="room-type-card-button"
        data-analytics-id="site_detail_opened_room_type"
        onClick={() =>
          open(
            buildRoomDetailPayloadForSiteReserve({
              roomTypeId,
              areaSlug,
              siteSlug,
            }),
          )
        }
        className={`${CARD_ACTION_CLASS_NAME} w-full cursor-pointer text-left`}
      >
        {children}
      </button>
    );
  }

  if (detailHref === null) {
    return (
      <div className="flex items-start gap-[16px] px-[16px] py-[8px]">
        {children}
      </div>
    );
  }

  return (
    <Link
      href={detailHref}
      data-testid="room-type-link"
      data-analytics-id="site_detail_clicked_room_type"
      className={CARD_ACTION_CLASS_NAME}
    >
      {children}
    </Link>
  );
}
